import { useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { X, FileText } from 'lucide-react';
import { cur } from '../lib/units';
import { woodPdf, woodSorts } from '../lib/woodPdf';
import { portalRoot } from './TourGuide';

// prices per assortment + seller / buyer before the timber list PDF for the buyer
export default function WoodPdfDialog({ t, tr, project, updateProject, onClose }) {
  const [f, setF] = useState(() => ({ prices: { ...(project.woodPrices || {}) }, seller: project.woodSeller || '', buyer: '' }));
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    updateProject((p) => ({ ...p, woodPrices: f.prices, woodSeller: f.seller }));
    try { const r = await woodPdf(tr, t, project, f); toast.success(`${t.woodSum}: ${r.sum.toLocaleString(undefined, { maximumFractionDigits: 2 })} fm`); onClose(); } catch { toast.error(t.trkPdfErr); }
    setBusy(false);
  };
  return createPortal(
    <div className="editor-backdrop" data-testid="wood-pdf-dialog">
      <div className="editor wood-pdf">
        <div className="editor-head"><h4><FileText size={18} /> {t.woodPdfTitle}</h4><button className="icon-btn" data-testid="wood-pdf-close-btn" onClick={onClose}><X size={16} /></button></div>
        <p className="muted small-hint">{t.woodPdfHint}</p>
        {woodSorts(tr).map((s, i) => (
          <label key={s} className="wood-price-row">{s} ({cur()}/fm)
            <input inputMode="decimal" data-testid={`wood-price-${i}`} value={f.prices[s] ?? ''} onChange={(e) => setF({ ...f, prices: { ...f.prices, [s]: e.target.value } })} />
          </label>
        ))}
        <label className="wood-price-row">{t.woodSeller}<input data-testid="wood-seller-input" value={f.seller} onChange={(e) => setF({ ...f, seller: e.target.value })} /></label>
        <label className="wood-price-row">{t.woodBuyer}<input data-testid="wood-buyer-input" value={f.buyer} onChange={(e) => setF({ ...f, buyer: e.target.value })} /></label>
        <button className="btn btn-green" data-testid="wood-pdf-create-btn" disabled={busy} onClick={go}><FileText size={16} /> {busy ? '…' : t.woodPdfBtn}</button>
      </div>
    </div>,
    portalRoot(),
  );
}
